@if (visible()) {
  <div class="timeline__content">
    <ng-content></ng-content>
  </div>
}
